import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../shared/Navbar";
import "./ViewAllAccounts.css";
import { LATEST_ACCOUNTS_URL } from "../../api/apiurls";
import { AuthContext } from "../../ContextApi/ContextApi";

const ViewOldNewAccounts = () => {
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);

  const { userName } = useContext(AuthContext);
  const agentName = userName;

  const navigate = useNavigate();

  useEffect(() => {
    if (!userName) {
      setAccounts([]);
      setLoading(false);
      return;
    }

    setLoading(true);

    fetch(LATEST_ACCOUNTS_URL(agentName))
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch");
        return res.json();
      })
      .then((data) => {
        setAccounts(data || []);
      })
      .catch((err) => {
        console.error("API error:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [userName]);

  // ✅ NAVIGATE TO PRINT PAGE
  const handlePrint = () => {
    if (!accounts.length) {
      alert("No records available to print");
      return;
    }

    navigate("/old-new-accounts-reports", {
      state: { accounts },
    });
  };

  return (
    <>
      <Navbar />

      <div className="ViewOldNewReportContainer">

        {/* PRINT TOP BAR */}
        <div className="ViewOldNewReportTopBar">
          <button
            className="ViewOldNewReportPrintBtn"
            onClick={handlePrint}
          >
            Print
          </button>
        </div>

        {/* HEADER */}
        <div className="ViewOldNewReportHeaderRow">
          <div className="ViewOldNewReportHeaderCell">
            Account No
          </div>
          <div className="ViewOldNewReportHeaderCell">
            Amount
          </div>
        </div>

        {/* DATA */}
        {loading ? (
          <div className="ViewOldNewReportLoading">
            Loading...
          </div>
        ) : accounts.length === 0 ? (
          <div className="ViewOldNewReportLoading">
            No records found
          </div>
        ) : (
          accounts.map((item, index) => {
            const hasPresentBalance =
              item.PresentBalance !== null &&
              item.PresentBalance !== undefined &&
              item.PresentBalance > 0;

            const amountToShow = hasPresentBalance
              ? item.PresentBalance
              : item.PreviousBalance || 0;

            return (
              <div
                className="ViewOldNewReportDataRow"
                key={index}
              >
                <div
                  className={`ViewOldNewReportCell ${
                    hasPresentBalance
                      ? "ViewOldNewPresentBalance"
                      : ""
                  }`}
                >
                  {item.AccountNo}
                </div>

                <div
                  className={`ViewOldNewReportCell ${
                    hasPresentBalance
                      ? "ViewOldNewPresentBalance"
                      : ""
                  }`}
                >
                  {Number(amountToShow).toFixed(2)}
                </div>
              </div>
            );
          })
        )}
      </div>
    </>
  );
};

export default ViewOldNewAccounts;
